<template>
  <div class="app-error">
    <slot name="txtBefore"></slot>
    <slot v-if="errorType" :name="`txtError${errorType}`"></slot>
    <MessageModal></MessageModal>
    <b-form>
      <Stepper
        :show-next="true"
        :show-prev="false"
        @next="$emit('done')"
      >
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
      <LogOut v-if="showLogout"></LogOut>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import { BForm } from 'bootstrap-vue'

import Stepper from './Stepper'
import processSteps from '../../mixins/processSteps'
import LogOut from '@/components/process/generic/LogOut'
import MessageModal from '@/components/generic/MessageView/MessageList'

export const stepName = 'error'

export default {
  name: 'ErrorStep',
  components: {
    MessageModal, LogOut, Stepper, BForm
  },
  props: {
    showPrev: {
      type: Boolean,
      default: true
    },
    errorType: {
      type: String,
      default: null
    },
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    processSteps(stepName)
  ]
}
</script>
